export const EMAIL_RESEND_COOLDOWN_SEC = 60
/** Mirrors CODE_TTL_MS in emailAuthActionsService.js — keep the two in sync. */
export const EMAIL_CODE_TTL_SEC = 5 * 60
